import { object, string } from "zod";

const EMAIL_REGEX =
    /^[\w!#$%&'*+\/=?^_`{|}~-]+(?:\.[\w!#$%&'*+\/=?^_`{|}~-]+)*@(?:[\w](?:[\w]*[\w])?\.)+[\w](?:[\w]*[\w])?$/;

export const NewsletterFormSchema = (validationErrorMessage: string) =>
    object({
        NewsletterEmail: string({
            required_error: validationErrorMessage,
        }).regex(EMAIL_REGEX, validationErrorMessage),
    });
